import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createReducer } from '@reduxjs/toolkit';
import { orderResult, setAddressViewValue, setAlternativeTariffType, setAvailablePeriods, setConvergenceTariffs, setMobileTariffs, setPopupVisibility } from '@fttb/common';
export var orderProgress = createReducer({
  region: null,
  isOpen: false,
  showCaptcha: null,
  orderResult: null,
  availablePeriods: null,
  alternativeTariffType: null,
  convergenceTariffs: null,
  mobileTariffs: null,
  mobileTariffsAliases: null,
  addressView: false,
  checkAddressOneFieldPopupEnabled: false
}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, setPopupVisibility.type, function (state) {
  state.isOpen = !state.isOpen;
}), setAlternativeTariffType.type, function (state, _ref) {
  var payload = _ref.payload;
  state.alternativeTariffType = payload;
}), setAvailablePeriods.type, function (state, _ref2) {
  var payload = _ref2.payload;
  state.availablePeriods = payload;
}), orderResult.type, function (state, _ref3) {
  var payload = _ref3.payload;
  state.orderResult = payload;
}), setConvergenceTariffs.type, function (state, _ref4) {
  var payload = _ref4.payload;
  state.convergenceTariffs = payload;
}), setMobileTariffs.type, function (state, _ref5) {
  var payload = _ref5.payload;
  state.mobileTariffs = payload;
}), setAddressViewValue.type, function (state, _ref6) {
  var payload = _ref6.payload;
  state.addressView = payload;
}));